module.exports = __webpack_public_path__ + "static/media/hirama.5c2cf77a.jpg";